// these functions can be used without importing
// ref: https://gist.github.com/vielhuber/afcb99fdf23febffe0199649e19642cb
export default {

  //Clean an Array      
  cleanArray(myArray, callback) {
    return myArray.filter((e) => {
      return (e != false && e !== null && e !== " " && e !== "");
    });
  }, 
  //Split an Array into chunks
  splitArray(myArray, chunk_size, callback) {
    var index = 0;
    var tempArray = []; 
    for (index = 0; index < myArray.length; index += chunk_size) {
      myChunk = myArray.slice(index, index+chunk_size);
      tempArray.push(myChunk);
    }
    callback(tempArray);
  },
  //Remove duplicates from array of objects by attribute
  removeDuplicatesByAttribute(myArray, attribute) {
    let arrayWithoutDuplicates = myArray.filter((v,i,a)=>a.findIndex(t=>(t[attribute] === v[attribute]))===i)     
    return arrayWithoutDuplicates;
  },
  //format Number [10000 -> 10.000]   
  formatNumber(number) {
    var formattedNumber = number.toLocaleString('de-DE',{minimumFractionDigits: 0, maximumFractionDigits: 0});
    return formattedNumber;
  },
  //remove Element from an Array by attribute
  removeElement(element, removeArray, attribute) {
    var newArray = removeArray.filter(function( obj ) {
      return obj[attribute] !== element;
    });
    return newArray;
  },
  
};